import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      fill: "#FF0E3E",
      rx: "9"
    }, null, -1),
    _createElementVNode("rect", {
      width: "2.571",
      height: "7.714",
      x: "10.715",
      y: "6.857",
      fill: "#fff",
      rx: "1.286"
    }, null, -1),
    _createElementVNode("rect", {
      width: "2.571",
      height: "2.571",
      x: "10.715",
      y: "15.857",
      fill: "#fff",
      rx: "1.286"
    }, null, -1)
  ])))
}
export default { render: render }